/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `Bez postižení` - Bez postižení * `Mentální postižení` - Mentální postižení * `Sluchové postižení` - Sluchové postižení * `Zrakové postižení` - Zrakové postižení * `Vady reči` - Vady reči * `Tělesné postižení` - Tělesné postižení * `Vývojové poruchy` - Vývojové poruchy * `Souběžné postižení více vadami` - Souběžné postižení více vadami * `Autismus` - Autismus * `Žák v zařízení pro výkon ústavní-ochranné výchovy` - Žák v zařízení pro výkon ústavní-ochranné výchovy * `Těžké mentální postižení` - Těžké mentální postižení
 */
export type DisabilityTypeEnum = 'Bez postižení' | 'Mentální postižení' | 'Sluchové postižení' | 'Zrakové postižení' | 'Vady reči' | 'Tělesné postižení' | 'Vývojové poruchy' | 'Souběžné postižení více vadami' | 'Autismus' | 'Žák v zařízení pro výkon ústavní-ochranné výchovy' | 'Těžké mentální postižení';

export const DisabilityTypeEnum = {
    BezPostien: 'Bez postižení' as DisabilityTypeEnum,
    MentlnPostien: 'Mentální postižení' as DisabilityTypeEnum,
    SluchovPostien: 'Sluchové postižení' as DisabilityTypeEnum,
    ZrakovPostien: 'Zrakové postižení' as DisabilityTypeEnum,
    VadyRei: 'Vady reči' as DisabilityTypeEnum,
    TlesnPostien: 'Tělesné postižení' as DisabilityTypeEnum,
    VvojovPoruchy: 'Vývojové poruchy' as DisabilityTypeEnum,
    SoubnPostienVceVadami: 'Souběžné postižení více vadami' as DisabilityTypeEnum,
    Autismus: 'Autismus' as DisabilityTypeEnum,
    KVZazenProVkonStavnOchrannVchovy: 'Žák v zařízení pro výkon ústavní-ochranné výchovy' as DisabilityTypeEnum,
    TkMentlnPostien: 'Těžké mentální postižení' as DisabilityTypeEnum
};